// src/components/servicepartner/ServicePartnerTechnikForm.jsx
import { VStack, HStack, Text, Input } from "@chakra-ui/react";

export default function ServicePartnerTechnikForm({ partnerTechnik, setPartnerTechnik }) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPartnerTechnik((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    setPartnerTechnik((prev) => ({ ...prev, [name]: checked }));
  };

  return (
    <VStack align="stretch" spacing={6} mt={8}>
      {/* ------------------ Fahrzeuge ------------------ */}
      <Text fontSize="lg" fontWeight="bold">Fahrzeuge</Text>

      <HStack>
        <Input
          placeholder="€/km Fahrtkosten"
          type="number"
          name="fahrtkostenKm"
          value={partnerTechnik.fahrtkostenKm || ""}
          onChange={handleChange}
          width="200px"
        />
        <label>
          <input
            type="checkbox"
            name="mitarbeiterInbegriffen"
            checked={partnerTechnik.mitarbeiterInbegriffen || false}
            onChange={handleCheckbox}
          />
          &nbsp;Mitarbeiter inbegriffen
        </label>
      </HStack>

      <HStack>
        <label>
          <input
            type="checkbox"
            name="pkwKombi"
            checked={partnerTechnik.pkwKombi || false}
            onChange={handleCheckbox}
          />
          &nbsp;PKW / Kombi
        </label>

        <label>
          <input
            type="checkbox"
            name="transporter"
            checked={partnerTechnik.transporter || false}
            onChange={handleCheckbox}
          />
          &nbsp;Transporter
        </label>

        <label>
          <input
            type="checkbox"
            name="lkwPritsche"
            checked={partnerTechnik.lkwPritsche || false}
            onChange={handleCheckbox}
          />
          &nbsp;LKW / Pritsche
        </label>
      </HStack>

      {/* ------------------ Messtechnik ------------------ */}
      <Text fontSize="lg" fontWeight="bold">Messtechnik</Text>

      {[
        { key: "kennlinienmessgeraet", label: "Kennlinienmessgerät", text: "kennlinienWelche" },
        { key: "solartaktor", label: "Solartaktor", text: "solartaktorWelche" },
        { key: "infrarotKamera", label: "Infrarot-Kamera", text: "infrarotWelche" },
        { key: "elektroLumineszenz", label: "Elektrolumineszenz-Kamera", text: "elektroLumineszenzWelche" },
        { key: "netzanalysegeraet", label: "Netzanalysegerät", text: "netzanalyseWelche" },
        { key: "stringmessgeraet", label: "Stringmessgerät", text: "stringmessgeraetWelche" },
        { key: "vdeMessung", label: "Messg. für VDE0100/0105 & IEC60364", text: "vdeWelche" },
      ].map((item) => (
        <HStack key={item.key} spacing={4}>
          <label>
            <input
              type="checkbox"
              name={item.key}
              checked={partnerTechnik[item.key] || false}
              onChange={handleCheckbox}
            />
            &nbsp;{item.label}
          </label>

          <Input
            placeholder="wenn ja: welche"
            name={item.text}
            value={partnerTechnik[item.text] || ""}
            onChange={handleChange}
          />
        </HStack>
      ))}

      {/* ------------------ Sonstige Technik ------------------ */}
      <Text fontSize="lg" fontWeight="bold">Sonstige Technik</Text>

      <HStack spacing={6}>
        <label>
          <input
            type="checkbox"
            name="rollgeruest"
            checked={partnerTechnik.rollgeruest || false}
            onChange={handleCheckbox}
          />
          &nbsp;Rollgerüst
        </label>

        <label>
          <input
            type="checkbox"
            name="pvReinigung"
            checked={partnerTechnik.pvReinigung || false}
            onChange={handleCheckbox}
          />
          &nbsp;PV-Reinigung
        </label>

        <label>
          <input
            type="checkbox"
            name="geruestteile"
            checked={partnerTechnik.geruestteile || false}
            onChange={handleCheckbox}
          />
          &nbsp;Gerüstteile
        </label>

        <label>
          <input
            type="checkbox"
            name="dachdeckerlift"
            checked={partnerTechnik.dachdeckerlift || false}
            onChange={handleCheckbox}
          />
          &nbsp;Dachdeckerlift
        </label>

         <label>
          <input
            type="checkbox"
            name="Hebebühne"
            checked={partnerTechnik.Hebebühne || false}
            onChange={handleCheckbox}
          />
          &nbsp;Hebebühne
        </label>

      </HStack>
    </VStack>
  );
}